async function getLidar(lidarId) {
    return this.api({
        url: `/public/lidar/${lidarId}`,
        method: 'GET'
    })
}

export default {
    pluginName: 'public',
    methods: {
        getLidar
    }
}